import Head from "next/head";
import Header from "./Header";
import Footer from "./Footer";
import useScrollToTop from "../hooks/useScrollTop";

export default function Layout({ title, children, companyInfo }) {
  useScrollToTop();
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed top-4 left-4 z-50 bg-brand-primary text-white font-medium focus:px-4 focus:py-2 rounded shadow-md"
      >
        Siirry sisältöön
      </a>
      <div className="flex flex-col min-h-screen">
        <Head>
          <title>{`${title} | Eläinklinikka`}</title>
        </Head>

        <Header companyInfo={companyInfo} />
        <main id="main" className="grow">
          {children}
        </main>
        <Footer companyInfo={companyInfo} />
      </div>
    </>
  );
}
